import { Vector3 } from "@babylonjs/core";
import { BaseFloor } from "./BaseFloor.js";

/**
 * 🔴 ÉTAGE 5 : NEXUS — BOSS FINAL (L'Étoile Fracturée)
 * Philosophy: RUPTURE
 *
 * IA Edition : Le hpMult est appliqué par EntityManager.spawnEnemy() via applyHpMult().
 * NexusBoss.applyHpMult() surcharge Enemy.applyHpMult() pour synchro maxHp + barre de vie.
 * Base : 80 HP → jusqu'à 120 HP si joueur très agressif (hpMult 1.5).
 */
export class Floor5 extends BaseFloor {

    // Requis par FloorGenerator.resetAllOrders()
    static resetSizeCache() {}

    static generate(room, roomIndex, runPosition, aiData) {
        switch (roomIndex) {
            case 0: return this._room1(room, aiData);
        }
    }

    // ─────────────────────────────
    // ROOM 1 — ARÈNE DE L'ÉTOILE FRACTURÉE
    // ─────────────────────────────
    static _room1(room, aiData) {
        const sp = 4;
        const platforms = [], arena = [], ext = [];

        const addP = (x, z, isArena = false, y = 0) => {
            const pos = new Vector3(x * sp, y, z * sp);
            room.addPlatform(pos);
            platforms.push(pos);
            (isArena ? arena : ext).push(pos);
        };

        // ── 1. COULOIR D'ENTRÉE (long pour la tension) ──
        for (let z = -18; z <= -9; z++) {
            for (let x = -1; x <= 1; x++) addP(x, z, false, 0);
        }

        // ── 2. ARÈNE : L'ÉTOILE FRACTURÉE ──
        const radius = 9;
        for (let x = -radius; x <= radius; x++) {
            for (let z = -radius; z <= radius; z++) {
                const dist = Math.sqrt(x * x + z * z);

                // Anneau externe
                if (dist >= 6.5 && dist <= 8.5) {
                    addP(x, z, true, 0);
                }
                // Croix centrale
                else if (Math.abs(x) <= 2 || Math.abs(z) <= 2) {
                    if (dist <= 8.5 && (Math.abs(x) + Math.abs(z) > 3)) {
                        addP(x, z, true, 0);
                    }
                }
                // Îlots intermédiaires
                else if (dist <= 4.5 && Math.abs(x) > 2 && Math.abs(z) > 2) {
                    addP(x, z, true, 0);
                }
            }
        }

        // ── 3. PLATEAU CENTRAL DU BOSS ──
        for (let x = -2; x <= 2; x++) {
            for (let z = -2; z <= 2; z++) {
                if (Math.abs(x) + Math.abs(z) <= 3) addP(x, z, true, 0);
            }
        }

        // ── SPAWN & SORTIE ──
        const spawnPos = new Vector3(0, 1, -17 * sp);
        room.setSpawnPosition(spawnPos);
        room.setExitPortal(new Vector3(0, 0, 8 * sp));

        // ── BOSS : spawn au centre de l'arène ──
        // hpMult est appliqué par EntityManager.spawnEnemy(type, pos, aiData)
        // qui appellera boss.applyHpMult(aiData.hpMult) juste après l'activation.
        room.enemyList = ["NEXUS"];
        room.addSpawnPoint(new Vector3(0, 1, 0));
    }
}